module.exports = __webpack_public_path__ + "f840e1fa9f72a8c537a33de728c3488c.png";